import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import { Assessor } from 'src/app/models/Assessor';
import {AssessorTestResult, Round} from '../../models/ReceivedPoll';
import { ShortVoter } from 'src/app/models/ShortVoter';
import { AssessorData } from 'src/app/models/AssessorData';

@Component({
  selector: 'app-assessors-closing',
  templateUrl: 'assessors-closing.component.html',
  styleUrls: ['./assessors-closing.component.less', '../../shared/common.less'],
})

export class AssessorsClosingComponent implements OnInit {
  @Input() assessors: Array<Assessor> = [];
  @Input() inactiveAssessors: ShortVoter[] = [];
  @Input() currentStep: number = 1;
  @Input() isTestVoteOpen: boolean = false;
  @Input() unsealStepReady: boolean = false;
  @Input() unsealedAssessors: Array<AssessorData> = [];
  @Input() isBallotUnsealed: boolean = false;
  @Input() rounds: Array<Round> = [];
  @Output() inviteAssessorsEvent = new EventEmitter();
  @Output() relaunchAssessorEvent = new EventEmitter();
  @Output() updateAssessorEvent = new EventEmitter();
  @Output() displayResultEvent = new EventEmitter();
  @Output() inviteAssessorsVoteEvent = new EventEmitter();
  @Output() closeAssessorsVoteEvent = new EventEmitter();
  @Output() validateTestVoteEvent = new EventEmitter<boolean>();
  @Input() remainingAssessors = 0;
  @Input() assessorQuorum: AssessorTestResult | null = null;
  @Input() testStepStatus: string = "";

  inviteAssessors() {
    this.inviteAssessorsEvent.emit();
  }

  relaunchAssessor(mail: string) {
    this.relaunchAssessorEvent.emit(mail);
  }

  inviteAssessorsVote() {
    this.inviteAssessorsVoteEvent.emit();
  }

  closeAssessorsVote() {
    this.closeAssessorsVoteEvent.emit();
  }

  validateTestPoll(event: boolean) {
    this.validateTestVoteEvent.emit(event);
  }

  ngOnInit(): void {
  }
}
